module.exports = __webpack_public_path__ + "img/1920_leuco_intro_img3.d6419140.png";